import { createVNode as _createVNode } from "vue";
import loginDialog from "@/layout/login.vue";
import { appInstance } from "@/main";
import { render, createVNode } from "vue";
export const login = () => {
  if (window.__login__) {
    return;
  }
  const vNode = defineComponent({
    components: {
      loginDialog
    },
    setup(props, {
      emit
    }) {
      const success = ref(false);
      const show = ref(true);
      const handleSuccess = () => {
        show.value = false;
        window.__login__ = null;
        dom.remove();
        window.location.reload();
      };
      const handleClose = () => {
        setTimeout(() => {
          show.value = false;
          window.__login__ = null;
          dom.remove();
        }, 4);
      };
      return () => _createVNode(loginDialog, {
        "showLogin": show.value,
        "onChangeShow": handleClose,
        "onSuccess": handleSuccess
      }, null);
    }
  });
  const dom = document.createElement("div");
  const instance = createVNode(vNode);
  //重要   上下文赋值
  instance.appContext = appInstance._context;
  const vNodeRender = render(instance, dom);
  document.body.append(dom);
  //全局单例
  window.__login__ = vNode;
};